import { hasValue } from '@famly/stat_ts-utils_has-value';
/**
 * Matches Apollo's error classes by `name`, which both Apollo 3 and Apollo 4 set, rather than
 * by `instanceof` against classes only one of them exports.
 */
export const isErrorNamed = (error, name) => hasValue(error) && typeof error === 'object' && error.name === name;
